export const getAll = async ({ commit, state }, query) => {
  try {
    // let { data } = await request(query).get("/newspapers");
    // commit("SET_DATA", { data: data, id: 'newspapers' });
    return data;
  } catch (e) {
    return Promise.reject(e);
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/navbar/actions.js